const steps = [
  {
    num: "1",
    title: "Intake your platform",
    desc: "List every product and its AI features. Point us at your model endpoints — your API key is read from an env var at run time, never sent to us.",
  },
  {
    num: "2",
    title: "Score against Article 50",
    desc: "Each product scored per clause — role (provider / deployer), verdict, ranked gaps, copy-paste fixes.",
  },
  {
    num: "3",
    title: "Run COMPL-AI benchmarks",
    desc: "Our eval worker runs the open-source COMPL-AI framework against your models and keeps the raw evidence — pinned versions, Inspect logs.",
  },
  {
    num: "4",
    title: "Sign one PDF report",
    desc: "Application gaps + model evidence merged into one hash-signed deliverable, clause-traceable and re-runnable on demand.",
  },
];

export default function Steps() {
  return (
    <section id="how" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="section-head">
          <p className="eyebrow">
            <i className="ri-route-line" />
            How it works
          </p>
          <h2 className="section-title">
            Four steps to a defensible Article 50 file
          </h2>
          <p className="section-lede">
            From connecting your model to shipping the PDF your auditor will read.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 max-w-6xl mx-auto">
          {steps.map((step, i) => (
            <div key={step.num} className="relative group">
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[60%] right-0 h-px bg-gradient-to-r from-primary-300 to-transparent" />
              )}
              <div className="flex flex-col items-center text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-lg md:text-xl font-bold mb-4 md:mb-5 shadow-lg shadow-primary-500/20">
                  {step.num}
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}